import { AutogiroMandateStatusEnum } from 'src/shared/models/enums/autogiroMandateStatus.enum';

export enum AutogiroStatusTabKeysEnum {
  New = 'New',
  PendingApproval = 'PendingApproval',
  NotApproved = 'NotApproved',
  Approved = 'Approved',
  PendingCancel = 'PendingCancel',
  Canceled = 'Canceled',
  Error = 'Error',
}

export interface AutogiroStatusTabItem {
  label: string;
  key: AutogiroStatusTabKeysEnum;
  values: AutogiroMandateStatusEnum[];
}

export const autogiroStatusTabs: AutogiroStatusTabItem[] = [
  {
    label: 'invoice:autogiroMandateStatus.New',
    key: AutogiroStatusTabKeysEnum.New,
    values: [AutogiroMandateStatusEnum.New],
  },
  {
    label: 'invoice:autogiroMandateStatus.PendingApproval',
    key: AutogiroStatusTabKeysEnum.PendingApproval,
    values: [AutogiroMandateStatusEnum.PendingApproval, AutogiroMandateStatusEnum.PendingCancel],
  },
  {
    label: 'invoice:autogiroMandateStatus.Approved',
    key: AutogiroStatusTabKeysEnum.Approved,
    values: [AutogiroMandateStatusEnum.Approved],
  },
  {
    label: 'invoice:autogiroMandateStatus.NotApproved',
    key: AutogiroStatusTabKeysEnum.NotApproved,
    values: [AutogiroMandateStatusEnum.NotApproved],
  },
  {
    label: 'invoice:autogiroMandateStatus.Canceled',
    key: AutogiroStatusTabKeysEnum.Canceled,
    values: [AutogiroMandateStatusEnum.Canceled],
  },
  {
    label: 'invoice:autogiroMandateStatus.Error',
    key: AutogiroStatusTabKeysEnum.Error,
    values: [AutogiroMandateStatusEnum.Error],
  },
];
